<template>
  <div
    id="main-page-content-view"
    class="is-flex is-flex-direction-column"
    style="width: 100%; max-height: 100vh"
  >
    <div
      class="
        is-flex
        is-flex-direction-row
        is-justify-content-space-around
        is-align-content-center
        mb-2
        p-2
      "
      style="background: #ebfffc"
    >
      <b-button
        tag="router-link"
        :to="{ name: 'EditYearlyReport', params: { reportId: reportId } }"
        >Editează</b-button
      >
      <b-button v-if="report && report.waitingForPrint" disabled
        >generating DOCX...</b-button
      >
      <b-button
        v-if="report && report.storagePath && !report.waitingForPrint"
        @click="downloadReport(report)"
        >Descarcă</b-button
      >

      <b-button
        v-if="!report || !report.storagePath"
        @click="regenerateDocx(report)"
        >Regenerează DocX</b-button
      >
    </div>

    <div class="columns is-centered m-0" style="max-height: 90vh">
      <div
        v-if="report && boolPreviewReport"
        class="column is-three-fifths mr-2"
        style="overflow-y: auto"
      >
        <div class="box has-background-light">
          <div v-html="report.html"></div>
        </div>
      </div>
      <div class="column ml-2" style="overflow-y: auto">
        <div class="" v-if="report" style="position: relative">
          <x-survey
            :content="formContent"
            :data="report.data"
         
            :readOnly="true"
          ></x-survey>
        </div>
         <div v-else>
           <h3>Nu gasesc raportul {{reportId}}</h3>
         </div>
      </div>
    </div>

    <!-- show while trying to submit answer to server -->
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="savingResult"
      :can-cancel="true"
    ></b-loading>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import XSurvey from "@/components/XSurvey.vue";
import { ToastProgrammatic as Toast } from "buefy";

import YearlyReport from "@/models/yearlyReport";
import ForceDownload from "@/utils/forceDownload";

export default {
  name: "ViewYearlyReportPage",

  components: {
    XSurvey,
    // ReportSummary
  },

  computed: {
    ...mapGetters({
      getYearlyReportById: "yearlyReports/getById",

      boolPreviewReport: "selection/boolPreviewReport",
      getClientById: "clients/getById",
    }),
    reportId() {
      return this.$route.params.reportId;
    },
    report() {
      if (!this.reportId) return null;
      return this.getYearlyReportById(this.reportId);
    },
    formContent() {
      return YearlyReport.getFormByVersionString(
        this.report.formVersionString || "8"
      );
    },
  },

  data: function () {
    return {
      isFullPage: false,
      savingResult: false,
    };
  },

  methods: {


    async regenerateDocx(report) {
      const patchedReport = JSON.parse(JSON.stringify(report, null, 2));

      patchedReport.waitingForPrint = true;
      delete patchedReport.storagePath;

      try {
        const newId = await this.$store.dispatch("yearlyReports/set", patchedReport);
        console.log("updated yearly report with id ", newId, patchedReport);
      } catch (error) {
        console.error("saving yearly report error: ", error);
        this.isErrorPosting = true;
        Toast.open({
          message: "Ooops! Could not regenerate report...",
          type: "is=danger",
          position: "is-bottom",
          duration: 5000,
        });
      }

      this.savingResult = false;
    },

    async downloadReport(report) {
      return ForceDownload.downloadFromFirebaseStorage(
        report.storagePath,
        "application/docx",
        YearlyReport.reportFilename(report)
      );
    },
  },
};
</script>

<style>
</style>
